import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HablemosPage.css';

const HUBSPOT_PORTAL_ID = '25730550';
const HUBSPOT_FORM_GUID = '07338dd3-a5af-40fc-8817-ad9235fbab0c';
const CONTACT_EMAIL = 'comercial@e-asy.es';
const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID;
const HABLEMOS_WEBHOOK_URL = process.env.REACT_APP_HABLEMOS_WEBHOOK_URL;

const HablemosPage = ({ darkMode, toggleDarkMode }) => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    message: '',
    interests: {},
  });

  const tercerSectorOptions = [
    { id: 'dependencia', label: 'Dependencia', desc: 'Gestión integral para servicios de atención a personas en situación de dependencia.' },
    { id: 'asilo-residencial', label: 'Asilo y residencial', desc: 'Control de plazas, residentes y equipos en centros residenciales.' },
    { id: 'infancia-mujer', label: 'Infancia y mujer', desc: 'Seguimiento de casos y programas en el ámbito de infancia y mujer.' },
  ];

  const vulpinId = 'vulpin-ia';

  const otrosServiciosOptions = [
    { id: 'vulpin-suite', label: 'Vulpin Suite' },
    { id: 'ciberseguridad', label: 'Ciberseguridad y Cumplimiento' },
    { id: 'ia-produccion', label: 'IA en Producción' },
    { id: 'desarrollo-web', label: 'Desarrollo Web y E-commerce' },
    { id: 'consultoria-microsoft-azure', label: 'Consultoría Microsoft / Azure / Google Workspace' },
    { id: 'ingenieria-cuota', label: 'Ingeniería a cuota (outsourcing tecnológico)' },
    { id: 'ia', label: 'Inteligencia Artificial' },
    { id: 'integraciones', label: 'Integraciones empresariales' },
    { id: 'cumplimiento-ia', label: 'Cumplimiento IA (Art. 4)' },
    { id: 'ia-privada', label: 'IA privada / soberana' },
    { id: 'software-medida', label: 'Software a medida' },
    { id: 'consultoria', label: 'Consultoría tecnológica' },
    { id: 'cloud-devops', label: 'Infraestructura cloud y DevOps' },
    { id: 'bi-datos', label: 'BI y explotación de datos' },
  ];

  const allInterestIds = [
    ...tercerSectorOptions.map((o) => o.id),
    vulpinId,
    ...otrosServiciosOptions.map((o) => o.id),
  ];

  const handleInterestChange = (id, checked) => {
    setFormData((prev) => ({
      ...prev,
      interests: { ...prev.interests, [id]: checked },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getSelectedInterestsText = () => {
    const labels = {};
    tercerSectorOptions.forEach((o) => { labels[o.id] = o.label; });
    labels[vulpinId] = 'Vulpin IA';
    otrosServiciosOptions.forEach((o) => { labels[o.id] = o.label; });
    return allInterestIds
      .filter((id) => formData.interests[id])
      .map((id) => labels[id] || id)
      .join(', ');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const interestsText = getSelectedInterestsText();
    const messageWithInterests = interestsText
      ? `Intereses: ${interestsText}\n\n${formData.message}`
      : formData.message;

    setLoading(true);
    try {
      const subject = `[Hablemos] Consulta de ${formData.firstname} ${formData.lastname}`;
      if (FORMSPREE_ID) {
        const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nombre: formData.firstname,
            apellidos: formData.lastname,
            email: formData.email,
            teléfono: formData.phone,
            mensaje: messageWithInterests,
            _subject: subject,
          }),
        });
        if (!res.ok) throw new Error('Error al enviar');
      } else if (HABLEMOS_WEBHOOK_URL) {
        const emailBody = [
          `Nombre: ${formData.firstname} ${formData.lastname}`,
          `Email: ${formData.email}`,
          formData.phone ? `Teléfono: ${formData.phone}` : null,
          '',
          messageWithInterests,
        ].filter(Boolean).join('\n');
        const res = await fetch(HABLEMOS_WEBHOOK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            to: CONTACT_EMAIL,
            cc: '',
            cc1: '',
            cc2: '',
            cc3: '',
            subject,
            text: emailBody,
          }),
        });
        if (!res.ok) throw new Error('Error al enviar');
      } else {
        const res = await fetch(
          `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              fields: [
                { name: 'firstname', value: formData.firstname },
                { name: 'lastname', value: formData.lastname },
                { name: 'email', value: formData.email },
                { name: 'phone', value: formData.phone },
                { name: 'message', value: messageWithInterests },
              ],
              context: { pageUri: window.location.href, pageName: 'Hablemos' },
            }),
          }
        );
        if (!res.ok) throw new Error('Error al enviar');
      }
      setSent(true);
    } catch (err) {
      setError(`No se pudo enviar. Escribe a ${CONTACT_EMAIL}`);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className={`hablemos-page ${darkMode ? 'dark' : 'light'}`}>
        <header className="hablemos-header">
          <Link to="/" className="hablemos-logo">
          <img src="/images/logotipo-01.png" alt="E-ASY" className="hablemos-logo-img" />
        </Link>
          <button type="button" className="hablemos-theme-toggle" onClick={toggleDarkMode} aria-label={darkMode ? 'Modo claro' : 'Modo oscuro'}>
            {darkMode ? '☀️' : '🌙'}
          </button>
        </header>
        <main className="hablemos-main hablemos-sent">
          <h1 className="hablemos-hero-title">Gracias</h1>
          <p className="hablemos-sent-text">Hemos recibido tu mensaje. Te contestaremos lo antes posible.</p>
          <Link to="/" className="hablemos-cta-button">Volver al inicio</Link>
        </main>
        <footer className="hablemos-footer">
          <Link to="/" className="hablemos-footer-link">Visitar e-asy.es</Link>
        </footer>
      </div>
    );
  }

  return (
    <div className={`hablemos-page ${darkMode ? 'dark' : 'light'}`}>
      <header className="hablemos-header">
        <Link to="/" className="hablemos-logo">
          <img src="/images/logotipo-01.png" alt="E-ASY" className="hablemos-logo-img" />
        </Link>
        <button type="button" className="hablemos-theme-toggle" onClick={toggleDarkMode} aria-label={darkMode ? 'Modo claro' : 'Modo oscuro'}>
          {darkMode ? '☀️' : '🌙'}
        </button>
      </header>

      <main className="hablemos-main">
        <section className="hablemos-hero">
          <h1 className="hablemos-hero-title">Hablemos</h1>
          <p className="hablemos-hero-subtitle">
            Cuéntanos en qué podemos ayudarte: elige los servicios o módulos que te interesan y envíanos tu consulta. Te respondemos desde aquí.
          </p>
        </section>

        <form className="hablemos-form" onSubmit={handleSubmit}>
          {/* Tercer sector */}
          <fieldset className="hablemos-fieldset">
            <legend className="hablemos-legend">Software para el tercer sector</legend>
            <p className="hablemos-fieldset-desc">
              Soluciones de gestión para entidades sociales: dependencia, centros residenciales, infancia y mujer.
            </p>
            {tercerSectorOptions.map((opt) => (
              <label key={opt.id} className="hablemos-check-label">
                <input
                  type="checkbox"
                  name="interests"
                  checked={!!formData.interests[opt.id]}
                  onChange={(e) => handleInterestChange(opt.id, e.target.checked)}
                  className="hablemos-checkbox"
                />
                <span className="hablemos-check-title">{opt.label}</span>
                <span className="hablemos-check-desc">{opt.desc}</span>
              </label>
            ))}
          </fieldset>

          {/* Vulpin */}
          <fieldset className="hablemos-fieldset hablemos-fieldset-vulpin">
            <legend className="hablemos-legend">Vulpin IA</legend>
            <p className="hablemos-vulpin-desc">
              <strong>Vulpin</strong> es nuestra inteligencia artificial que conoce el ámbito social porque se alimenta de cada caso concreto dentro de tu entidad. Conecta los módulos de gestión con las herramientas que ya usas: Microsoft Business Central, Google Workspace, Microsoft 365 y muchas otras. Si te interesa Vulpin, márcalo y te contamos cómo encajarlo en tu organización.
            </p>
            <label className="hablemos-check-label">
              <input
                type="checkbox"
                name="interests"
                checked={!!formData.interests[vulpinId]}
                onChange={(e) => handleInterestChange(vulpinId, e.target.checked)}
                className="hablemos-checkbox"
              />
              <span className="hablemos-check-title">Me interesa Vulpin IA</span>
            </label>
          </fieldset>

          {/* Otros servicios */}
          <fieldset className="hablemos-fieldset">
            <legend className="hablemos-legend">Otros servicios E-ASY</legend>
            <p className="hablemos-fieldset-desc">
              Consultoría tecnológica, ERP, Vulpin, IA, automatización, cloud, BI, ciberseguridad y más.
            </p>
            <div className="hablemos-check-grid">
              {otrosServiciosOptions.map((opt) => (
                <label key={opt.id} className="hablemos-check-label hablemos-check-label-inline">
                  <input
                    type="checkbox"
                    name="interests"
                    checked={!!formData.interests[opt.id]}
                    onChange={(e) => handleInterestChange(opt.id, e.target.checked)}
                    className="hablemos-checkbox"
                  />
                  <span className="hablemos-check-title">{opt.label}</span>
                </label>
              ))}
            </div>
          </fieldset>

          {/* Datos de contacto */}
          <fieldset className="hablemos-fieldset hablemos-fieldset-contact">
            <legend className="hablemos-legend">Tus datos</legend>
            <div className="hablemos-input-group">
              <label className="hablemos-input-label">
                <span className="hablemos-label-text">Nombre <span className="hablemos-required">*</span></span>
                <input type="text" name="firstname" value={formData.firstname} onChange={handleChange} required className="hablemos-input" placeholder="Tu nombre" />
              </label>
              <label className="hablemos-input-label">
                <span className="hablemos-label-text">Apellidos</span>
                <input type="text" name="lastname" value={formData.lastname} onChange={handleChange} className="hablemos-input" placeholder="Tus apellidos" />
              </label>
            </div>
            <label className="hablemos-input-label">
              <span className="hablemos-label-text">Email <span className="hablemos-required">*</span></span>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required className="hablemos-input" placeholder="tu@email.com" />
            </label>
            <label className="hablemos-input-label">
              <span className="hablemos-label-text">Teléfono</span>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="hablemos-input" placeholder="Opcional" />
            </label>
            <label className="hablemos-input-label">
              <span className="hablemos-label-text">Mensaje</span>
              <textarea name="message" value={formData.message} onChange={handleChange} className="hablemos-textarea" placeholder="Cuéntanos brevemente tu proyecto o duda..." rows={4} />
            </label>
          </fieldset>

          {error && <p className="hablemos-error">{error}</p>}
          <button type="submit" className="hablemos-submit" disabled={loading}>
            {loading ? 'Enviando…' : 'Enviar'}
          </button>
        </form>
      </main>

      <footer className="hablemos-footer">
        <Link to="/" className="hablemos-footer-link">Visitar e-asy.es</Link>
      </footer>
    </div>
  );
};

export default HablemosPage;
